import { render } from "./message-merger.vue?vue&type=template&id=a9c3fbce&scoped=true&ts=true"
import script from "./message-merger.vue?vue&type=script&lang=ts"
export * from "./message-merger.vue?vue&type=script&lang=ts"

import "./message-merger.vue?vue&type=style&index=0&id=a9c3fbce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c3fbce"]])

export default __exports__